import { HttpService } from '@app/@core/services/http.service';
import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalService } from '@app/@core/services/local.service';
import { ChangeDetectorRef } from '@angular/core';
import { take, takeUntil } from 'rxjs';
import { AppConstants } from '@app/@core/entities/app-constants';
import { CommonService } from '@app/shared/services/common.service';
import { ManageProfileService } from '@app/pages/manage-profile/manage-profile.service';
import { ComplaintFormService } from '../complaint-form.service';
import { AlertService } from '@app/@core/services/alert.service';
import { FingerprintPortalService } from '@app/fingerprint-portal/fingerprint-portal.service';
@Component({
  standalone: false,
  selector: 'app-update-email',
  templateUrl: './update-email.component.html',
  styleUrls: ['./update-email.component.scss']
})
export class UpdateEmailComponent implements OnInit, OnDestroy {
  toastMessages: any[] = [];
  genericMessages: any[] = [];
  placeholderMessages: any[] = [];
  showSecond = false;
  @ViewChild('otpFirst') otpFirstInput!: ElementRef;

  otp: string[] = ['', '', '', '', '', ''];
  timerActive = false;
  timeRemaining = 45;
  timerDisplay = '00:45';
  timerInterval: any = null;
  isResending = false;
  titleStr = 'Update Complainant Email Address';
  newEmail = '';
  oldEmail = '';
  type = 'email';
  invalidEmail = false;
  emailTooLong = false;
  paramEmail = '';
  person_id = 0;
  // Removed unused isMobile and resizeObservable$
  errorMessage: any = '';
  errorMessages: any = {};
  toastMessage: any = {};
  showToast: boolean = false;
  toastTitle: string = ''
  toastType = '';
  toastMessageText = '';
  toastTimer: any;
  genericMessage: any = {};
  placeholderMessage: any = {};
  emailTooltip = false;
  disableFlag = false;
  // Removed unused OTP recovery fields
  isVarificationSent: boolean = false;
  verifyUpdate: any = 'Verify and Update Email';
  emailLabel: any = 'Complainant Email Address';
  sameEmail = false;
  isPrimaryAndRecoverySameEmail = false;
  sameNumber = false;
  fieldFocus = false;
  emailExist = false;
  recoveryAttempts = 0;
  maxAttempts = 5; // Default fallback - will be updated from API
  recoveryResendDisabledUntil: number | null = null; // timestamp until which resend is disabled
  resendCount = 0;
  maxResendCount = 7; // Default fallback - will be updated from API
  isBlocked = false;
  otpDigits: string[] = [];
  resendTimer = 30; // Default 30 seconds - will be updated from API
  otpLockoutDuration = 3; // Default 3 minutes - will be updated from API
  otpResendCooldown = 1; // Default 1 minute - will be updated from API
  otpResendLockoutDuration = 15; // Default 15 minutes - hardcoded lockout after max attempts
  formattedTime = '00:00';
  resendBlockedUntil: number | null = null; // timestamp until which resend is disabled
  resendBlockTimer: any = null;
  resendBlockTimeRemaining = 0;
  verificationBlockedUntil: number | null = null; 
  verificationBlockTimer: any = null;
  verificationBlockTimeRemaining = 0;
  emailAlredyExist: boolean = false;
  isCheckingEmail: boolean = false;
  otpTouched = false;
  showOtpError = false;
  private destroy$ = new Subject<void>();
  // Add this property to track email verification status
  isEmailVerified: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UpdateEmailComponent>,
    private manageProfileService: ManageProfileService,
    private complaintFormService: ComplaintFormService,
    private localstorage: LocalService,
    private cdr: ChangeDetectorRef,
    private httpService: HttpService,
    private commonService: CommonService,
    private alertService: AlertService,
    private fingerprintService: FingerprintPortalService
  ) { }
  private loadDropdownDataMessages() {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=PLACEHOLDER MESSAGES'),
    ]).subscribe({
      next: (item: any) => {
        this.errorMessages = item[0].data;
        this.toastMessages = item[1].data;
        this.genericMessages = item[2].data;
        this.placeholderMessages = item[3].data;
        this.errorMessage = {};
        this.errorMessages.forEach((message: any) => {
          if (message.key && message.value !== undefined) {
            this.errorMessages[message.key] = message.value;
          }
        });
        this.errorMessage = { ...this.errorMessages };
        window.localStorage.setItem('errorMessages', JSON.stringify(this.errorMessages));
        this.toastMessage = {};
        this.toastMessages.forEach((message: any) => {
          if (message.key && message.value !== undefined) {
            this.toastMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('toastMessages', JSON.stringify(this.toastMessages));
        this.genericMessage = {};
        this.genericMessages.forEach((message: any) => {
          if (message.key && message.value !== undefined) {
            this.genericMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('genericMessages', JSON.stringify(this.genericMessages));
        this.placeholderMessage = {};
        this.placeholderMessages.forEach((message: any) => {
          if (message.key && message.value !== undefined) {
            this.placeholderMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('placeholderMessages', JSON.stringify(this.placeholderMessages));
      },
      error: (error: any) => {
        console.error('Error loading dropdown data:', error);
      }
    });
  }

  ngOnInit(): void {

    this.loadDropdownDataMessages();
    this.loadOtpValidationRules();

    try {
      if (window.localStorage) {
        this.errorMessages = JSON.parse(window.localStorage.getItem('errorMessage').toString());
        console.log(JSON.stringify(this.errorMessages));
        this.toastMessage = JSON.parse(window.localStorage.getItem('toastMessage').toString());
        console.log(JSON.stringify(this.toastMessage));
        this.genericMessage = JSON.parse(window.localStorage.getItem('genericMessage').toString());
        console.log(JSON.stringify(this.genericMessage));
        this.placeholderMessage = JSON.parse(window.localStorage.getItem('placeholderMessage').toString());
        console.log(JSON.stringify(this.placeholderMessage));
      }
    } catch (e) {
      console.log(e);
    }

    try {
      const isBlocked = this.localstorage.getItem('isEmailChangeBlocked').toString();
      const blockTime = new Date(this.localstorage.getItem('emailChangeBlockTime'));
      const currentTime = new Date();
      const diff = Math.abs(currentTime.getTime() - blockTime.getTime());
      const fifteenMins = 15 * 60 * 1000;

      if (diff < fifteenMins && isBlocked === 'true') {
        this.isBlocked = true;
      } else {
        this.isBlocked = false;
        this.localstorage.removeItem('isEmailChangeBlocked');
        this.localstorage.removeItem('emailChangeBlockTime');
      }
    } catch (e) {
      console.log(e);
    }



    this.migrateOldResendData();

    // Check for verification lockout
    try {
      const recoveryAttempts = parseInt(this.localstorage.getItem(this.getRecoveryAttemptKey()) || '0');
      const recoveryAttemptTime = this.localstorage.getItem(this.getRecoveryAttemptTimeKey());

      if (recoveryAttemptTime && recoveryAttempts >= this.maxAttempts) {
        const blockTime = new Date(recoveryAttemptTime);
        const currentTime = new Date();
        const lockoutMs = this.otpLockoutDuration * 60 * 1000;
        const diff = currentTime.getTime() - blockTime.getTime();

        if (diff < lockoutMs) {
          this.recoveryAttempts = recoveryAttempts;
          this.verificationBlockedUntil = blockTime.getTime() + lockoutMs;
          this.verificationBlockTimeRemaining = Math.ceil((lockoutMs - diff) / 1000);
          this.startVerificationBlockTimer();
        } else {
          this.localstorage.removeItem(this.getRecoveryAttemptKey());
          this.localstorage.removeItem(this.getRecoveryAttemptTimeKey());
          this.recoveryAttempts = 0;
          this.verificationBlockTimeRemaining = 0;
        }
      }
    } catch (e) {
      console.log(e);
    }

    try {
      const resendCount = parseInt(this.localstorage.getItem(this.getResendCountKey()) || '0');
      const resendBlockTime = this.localstorage.getItem(this.getResendBlockTimeKey());

      if (resendBlockTime && resendCount >= this.maxResendCount) {
        const blockTime = new Date(resendBlockTime);
        const currentTime = new Date();
        const diff = Math.abs(currentTime.getTime() - blockTime.getTime());
        const fifteenMins = 15 * 60 * 1000;

        if (diff < fifteenMins) {
          this.resendCount = resendCount;
          this.resendBlockedUntil = blockTime.getTime() + fifteenMins;
          this.resendBlockTimeRemaining = this.getCurrentFieldRemainingTime();
          this.startResendBlockTimer();
        } else {
          this.localstorage.removeItem(this.getResendCountKey());
          this.localstorage.removeItem(this.getResendBlockTimeKey());
          this.resendCount = 0;
          this.resendBlockTimeRemaining = 0;
        }
      } else if (resendCount < this.maxResendCount) {
        this.resendCount = resendCount;
        this.resendBlockTimeRemaining = 0;
      } else {
        this.resendCount = 0;
        this.resendBlockTimeRemaining = 0;
      }
    } catch (e) {
      console.log(e);
    }

    this.type = this.data?.emailType || '';
    console.log("this.data ---> " + JSON.stringify(this.data));
    if (this.type === 'primaryEmail') {
      this.titleStr = this.data?.titleStr ? this.data?.titleStr : 'Change Email Address';
      this.oldEmail = this.data.currentEmail.toString();
      this.newEmail = this.data.currentEmail.toString();
      this.verifyUpdate = 'Verify';
      this.emailLabel = 'Complainant Email Address';
    } else {
      this.paramEmail = this.data.primaryEmail || '';
    }
  }

  validateEmail(email: string) {
    this.sameEmail = false;
    this.emailExist = false;
    this.isPrimaryAndRecoverySameEmail = false;
    this.invalidEmail = false;
    this.emailTooLong = false;
    this.emailAlredyExist = false;

    if (!this.errorMessage || typeof this.errorMessage !== 'object') {
      this.errorMessage = {};
    }

    if (email === '' || email == undefined) {
      this.invalidEmail = false;
      this.emailTooLong = false;
      this.errorMessage = this.errorMessages['M0014'];
      this.cdr.detectChanges();
      return;
    }

    const emailControl = { value: email };
    // const emailValidator = Validators.email(emailControl as any);
    const emailValidator = /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
    const maxLengthValidator = Validators.maxLength(255)(emailControl as any);

    if (maxLengthValidator) {
      this.emailTooLong = true;
      this.errorMessage = { ...this.errorMessages, M0015: 'Email must be at most 255 characters.' };
      this.cdr.detectChanges();
      return;
    }
    const result = emailValidator.test(email);

    if (!result) {
      this.invalidEmail = true;
      this.errorMessage = this.errorMessages['M0015'];
      this.cdr.detectChanges();
      return;
    }


    if (email === this.paramEmail) {
      this.isPrimaryAndRecoverySameEmail = true;
      return;
    }

    this.invalidEmail = false;
    this.cdr.detectChanges();
  }

  @HostListener('keydown', ['$event'])
  onUnifiedKeydown(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const fieldType = this.getFieldType(target);

    if (!fieldType) return;

    const config = this.fieldConfigs[fieldType];
    if (!this.isKeyAllowed(event.key, config)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onUnifiedPaste(event: ClipboardEvent): void {
    const target = event.target as HTMLInputElement;
    const fieldType = this.getFieldType(target);

    if (!fieldType) return;

    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const config = this.fieldConfigs[fieldType];

    if (config.pasteValidator.test(pastedData)) {
      const originalFocusState = this.fieldFocus;
      this.fieldFocus = false;

      if (fieldType === 'email') {
        this.newEmail = pastedData;
        target.value = pastedData;
        config.inputHandler(target, pastedData);
      }
      else if (fieldType === 'otp') {
        const index = this.getOtpIndex(target);
        if (index !== undefined && pastedData.length === 1) {
          this.otp[index] = pastedData;
          target.value = pastedData;
          config.inputHandler(target, pastedData, index);
        }
      }

      setTimeout(() => {
        this.fieldFocus = originalFocusState;
        this.cdr.detectChanges();
      }, 10);
    }
  }

  @HostListener('input', ['$event'])
  onUnifiedInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    const fieldType = this.getFieldType(target);

    if (!fieldType) return;

    const config = this.fieldConfigs[fieldType];
    config.inputHandler(target, target.value, this.getOtpIndex(target));
  }

  onEmailFocus(): void {
    this.fieldFocus = true;
  }

  onOtpFocus(): void {
    this.fieldFocus = true;
    this.otpTouched = true;
  }


  private getFieldType(target: HTMLInputElement): string | null {
    if (target.id === 'inputfield_updateContact_email') return 'email';
    if (target.classList.contains('otp-input')) return 'otp';
    return null;
  }

  private getOtpIndex(target: HTMLInputElement): number | undefined {
    return target.dataset['index'] ? parseInt(target.dataset['index'], 10) : undefined;
  }

  private isKeyAllowed(key: string, config: any): boolean {
    const isNumber = /^\d$/.test(key);
    const isLetter = /^[a-zA-Z]$/.test(key);
    const isAllowedKey = config.allowedKeys.includes(key);
    const isSpecialChar = config.allowSpecialChars.includes(key);

    const lettersAllowed = config.allowLetters !== false;

    return isAllowedKey ||
      (isNumber && config.allowNumbers) ||
      (isLetter && lettersAllowed) ||
      isSpecialChar;
  }

  private focusFirstInput(): void {
    setTimeout(() => {
      if (this.otpFirstInput?.nativeElement) {
        this.otpFirstInput.nativeElement.focus();
      }
    }, 0);
  }

  startTimer(): void {
    this.clearTimer();
    this.timerActive = true;
    this.timeRemaining = this.resendTimer;
    this.updateTimerDisplay();

    this.timerInterval = setInterval(() => {
      this.timeRemaining--;
      this.updateTimerDisplay();

      if (this.timeRemaining <= 0) {
        this.clearTimer();
        this.timerActive = false;
        this.timeRemaining = 0;
        this.updateTimerDisplay();
        this.cdr.detectChanges();
      }
    }, 1000);
  }

  clearTimer(): void {
    if (this.timerInterval !== null) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  updateTimerDisplay(): void {
    const minutes = Math.floor(this.timeRemaining / 60);
    const seconds = this.timeRemaining % 60;
    this.timerDisplay = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  startResendBlockTimer(): void {
    const updateTimer = () => {
      const remainingTime = this.getCurrentFieldRemainingTime();

      if (remainingTime > 0) {
        this.resendBlockTimeRemaining = remainingTime;
        this.resendBlockTimer = setTimeout(updateTimer, 1000);
      } else {
        this.resendBlockTimeRemaining = 0;
        this.resendCount = 0;
        this.resendBlockedUntil = null;
        this.localstorage.removeItem(this.getResendCountKey());
        this.localstorage.removeItem(this.getResendBlockTimeKey());
        this.localstorage.removeItem('emailResendCount');
        this.localstorage.removeItem('emailResendBlockTime');
        this.localstorage.removeItem('recoveryEmailResendCount');
        this.localstorage.removeItem('recoveryEmailResendBlockTime');
        if (this.resendBlockTimer) {
          clearTimeout(this.resendBlockTimer);
          this.resendBlockTimer = null;
        }
      }
    };
    updateTimer();
  }

  startVerificationBlockTimer(): void {
    const updateTimer = () => {
      if (this.verificationBlockedUntil) {
        const currentTime = new Date().getTime();
        const remainingMs = this.verificationBlockedUntil - currentTime;
        
        if (remainingMs > 0) {
          this.verificationBlockTimeRemaining = Math.ceil(remainingMs / 1000);
          this.verificationBlockTimer = setTimeout(updateTimer, 1000);
        } else {
          this.verificationBlockTimeRemaining = 0;
          this.verificationBlockedUntil = null;
          this.recoveryAttempts = 0;
          this.localstorage.removeItem(this.getRecoveryAttemptKey());
          this.localstorage.removeItem(this.getRecoveryAttemptTimeKey());
          if (this.verificationBlockTimer) {
            clearTimeout(this.verificationBlockTimer);
            this.verificationBlockTimer = null;
          }
        }
      }
    };
    updateTimer();
  }

  clearResendBlockTimer(): void {
    if (this.resendBlockTimer) {
      clearTimeout(this.resendBlockTimer);
      this.resendBlockTimer = null;
    }
  }

  clearVerificationBlockTimer(): void {
    if (this.verificationBlockTimer) {
      clearTimeout(this.verificationBlockTimer);
      this.verificationBlockTimer = null;
    }
  }

  getResendBlockTimeDisplay(): string {
    const minutes = Math.floor(this.resendBlockTimeRemaining / 60);
    const seconds = this.resendBlockTimeRemaining % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  getVerificationBlockTimeDisplay(): string {
    const minutes = Math.floor(this.verificationBlockTimeRemaining / 60);
    const seconds = this.verificationBlockTimeRemaining % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  onOtpChange(index: number, event: Event): void {
    const input = event.target;

    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    if (input.value) {
      const numericValue = input.value.replace(/\D/g, '');
      if (input.value !== numericValue) {
        input.value = numericValue;
      }
      this.otp[index] = numericValue;

      if (this.showOtpError) {
        this.showOtpError = false;
        this.errorMessage = '';
      }
    } else {
      this.otp[index] = '';

      if (this.otpTouched && this.otp.join('').length === 0) {
        this.showOtpErrorMessage();
      }
    }

    if (input.value && index < 5) {
      const nextElement = input.parentElement?.children?.[index + 1];
      if (nextElement instanceof HTMLInputElement) {
        nextElement.focus();
      }
    }

    if (input.value === '' && index > 0) {
      const prevElement = input.parentElement?.children?.[index - 1];
      if (prevElement instanceof HTMLInputElement) {
        prevElement.focus();
      }
    }
  }

  private showOtpErrorMessage(): void {
    this.showOtpError = true;

    if (this.type === 'primaryEmail') {
      this.errorMessage = this.errorMessages['M0045'];
    } else if (this.type === 'recoveryEmail') {
      this.errorMessage = this.errorMessages['M0046'];
    } else if (this.type === 'phoneNumber') {
      this.errorMessage = this.errorMessages['M0038'];
    }
  }


  resendOtp(): void {
    if (this.isCurrentFieldMaxResendsReached() || this.getCurrentFieldRemainingTime() > 0) {
      return;
    }

    this.otp = ['', '', '', '', '', ''];
    this.isResending = true;

    this.otpTouched = false;
    this.showOtpError = false;
    this.errorMessage = '';

    const currentCount = this.getCurrentFieldResendCount();
    const newCount = currentCount + 1;

    this.localstorage.setItem(this.getResendCountKey(), newCount.toString());

    this.resendCount = newCount;

    if (newCount >= this.maxResendCount) {
      const blockTime = new Date();
      this.localstorage.setItem(this.getResendBlockTimeKey(), blockTime.toISOString());
      this.resendBlockedUntil = blockTime.getTime() + (this.otpResendLockoutDuration * 60 * 1000);
      this.resendBlockTimeRemaining = this.getCurrentFieldRemainingTime();
      this.startResendBlockTimer();
      return;
    }
    const msg = this.toastMessage['T0024'];
    this.showSuccessToastMsg(msg);
    this.disableFlag = true;
    this.startTimer();
    this.sendOTPMail();
    this.focusFirstInput();
  }

  cancel(): void {
    this.dialogRef.close({ response: 'cancel' });
  }

  onlyNumeric(event: KeyboardEvent): boolean {
    const key = event.key;
    const isNumber = /^\d$/.test(key);
    const isControlKey = event.ctrlKey || event.altKey ||
      key === 'Tab' ||
      key === 'Delete' ||
      key === 'Backspace' ||
      key === 'ArrowLeft' ||
      key === 'ArrowRight' ||
      key === 'Home' ||
      key === 'End';

    if (!isNumber && !isControlKey) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  onClose() {
    this.dialogRef.close({ response: 'cancel' });
  }


  resetEmailValidationFlags(): void {
    this.invalidEmail = false;
    this.emailTooLong = false;
    this.sameEmail = false;
    this.isPrimaryAndRecoverySameEmail = false;
    this.emailExist = false;
  }

  resetResendBlocking(): void {
    this.resendCount = 0;
    this.resendBlockedUntil = null;
    this.resendBlockTimeRemaining = 0;
    this.clearResendBlockTimer();
    this.localstorage.removeItem(this.getResendCountKey());
    this.localstorage.removeItem(this.getResendBlockTimeKey());

    if (this.type === 'phoneNumber') {
      this.localstorage.removeItem('isPhoneChangeBlocked');
      this.localstorage.removeItem('phoneChangeBlockTime');
    } else {
      this.recoveryAttempts = 0;
      this.localstorage.removeItem('isEmailChangeBlocked');
      this.localstorage.removeItem('emailChangeBlockTime');
    }
  }


  sendOTPMail() {
    this.complaintFormService.sendOTPEmail(this.newEmail).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {

        console.log('OTP sent successfully', response);
      },
      error: (error) => {
        console.error('Error sending OTP', error);
      }
    });
  }

  sendVerification() {
    const isCurrentFieldBlocked = this.isCurrentFieldBlocked();
    const currentFieldRemainingTime = this.getVerificationBlockTimeDisplay();

    if (currentFieldRemainingTime > "00:00") {
      let msg = this.toastMessage['T0029'];
      // const minutes = Math.floor(currentFieldRemainingTime / 60);
      // const seconds = currentFieldRemainingTime % 60;
      // const remainingTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      const remainingTime = currentFieldRemainingTime;
      msg = msg.replace('{N}', remainingTime);
      this.showFailureToastMsg(msg);

      return;
    }

    if (this.isBlocked) {
      let msg = this.toastMessage['T0029'];
      this.showFailureToastMsg(msg);
      return;
    }

    if (this.resendCount === 0) {
      this.resendCount = 1;
      this.localstorage.setItem(this.getResendCountKey(), '1');
    }

    if (this.type === 'primaryEmail') {
      if (this.invalidEmail || this.emailTooLong || this.sameEmail || this.isPrimaryAndRecoverySameEmail) {
        return;
      }

      const msg = this.toastMessage['T0024'];
      this.showSuccessToastMsg(msg);
      this.disableFlag = true;
      this.showSecond = true;
      this.sendOTPMail();
      this.focusFirstInput();
      this.isVarificationSent = true;
      this.otpTouched = false;
      this.showOtpError = false;
      this.errorMessage = '';
    } else {
      const msg = this.toastMessage['T0025'];
      this.showSuccessToastMsg(msg);
      this.disableFlag = true;
      this.showSecond = true;
      this.focusFirstInput();
      this.otpTouched = false;
      this.showOtpError = false;
      this.errorMessage = '';
      this.isVarificationSent = true;
    }

  }

  verifyOtp(): void {
    const otpValue = this.otp.join('');

    if (otpValue.length < 6) {
      this.errorMessage = this.errorMessages['M0038'];
      return;
    }


    this.errorMessage = '';
    this.clearTimer();
    this.complaintFormService.verifyEmail(this.newEmail, otpValue).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (
          response.status === 'success' &&
          response.data &&
          response.data.success === false &&
          response.data.message === 'Invalid OTP.'
        ) {
          if(this.recoveryAttempts >= this.maxAttempts){
            this.recoveryAttempts = 0;
          }
          this.recoveryAttempts++;
          // Handle API response indicating incorrect OTP
          this.showOtpErrorToast(this.recoveryAttempts);
          if (this.recoveryAttempts >= this.maxAttempts) {
            this.isBlocked = true;
            this.localstorage.setItem('isEmailChangeBlocked', 'true');
            this.localstorage.setItem('emailChangeBlockTime', Date.now().toString());

            this.otp = ['', '', '', '', '', ''];

            const blockTime = new Date();
            this.localstorage.setItem(this.getRecoveryAttemptKey(), this.recoveryAttempts.toString());
            this.localstorage.setItem(this.getRecoveryAttemptTimeKey(), blockTime.toISOString());
            this.verificationBlockedUntil = blockTime.getTime() + (this.otpLockoutDuration * 60 * 1000);
            this.verificationBlockTimeRemaining = this.otpLockoutDuration * 60;
            this.startVerificationBlockTimer();
          } else {
            this.localstorage.setItem(this.getRecoveryAttemptKey(), this.recoveryAttempts.toString());
          }
          // Set isEmailVerified to false on failure
          window.sessionStorage.setItem('isEmailVerified', 'false');
        } else if (response.data && response.data.success) {
          // this.sendMailUpdateNotification('primary');
          // this.showSuccessToastMsg(this.toastMessage['T0026']);
          // Set isEmailVerified to true on success
          // window.sessionStorage.setItem('isEmailVerified', 'true');
          const msg = this.toastMessage['T0047'];
          this.showSuccessToastMsg(msg);
          if (this.type === 'primaryEmail') {
            this.notifyPrimaryEmailUpdate();
          }
          this.dialogRef.close({ response: 'success', type: this.type, newEmail: this.newEmail, });
        } else {
          this.clearTimer();
          this.timerActive = false;
          const msg = response?.data?.message || 'Failed to change primary email. Please try again.';
          if (response.data.success === true) { this.showFailureToastMsg(msg); }
          // Set isEmailVerified to false on failure
          if(msg === "OTP has expired."){
            this.showFailureToastMsg(this.toastMessage['T0008']);
          }
          window.sessionStorage.setItem('isEmailVerified', 'false');
        }
      },
      error: (error) => {
        console.error('Error changing primary email', error);
        const msg = error?.error?.message || 'Failed to change ' + this.type + ' email. Please try again.';
        this.showFailureToastMsg(msg);
        // Set isEmailVerified to false on error
        window.sessionStorage.setItem('isEmailVerified', 'false');
      }
    });

  }


  closeToast() {
    this.showToast = false;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }

  closeToastMsg(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.parentElement.removeChild(element);
    }
  }

  showOtpErrorToast(attempts: number) {
    let toastMessage = '';

    const remainingAttempts = this.maxAttempts - attempts;

if (attempts >= this.maxAttempts) {
toastMessage = AppConstants.verificationLocked.replace('{minutes}', this.otpLockoutDuration.toString());
} else if (remainingAttempts > 0) {
toastMessage = AppConstants.incorrectAttempt.replace('{remainingAttempts}', remainingAttempts.toString());
} else {
toastMessage = this.toastMessage['T0005'];
}
this.showFailureToastMsg(toastMessage);
}


  sendMailUpdateNotification(type) {
    let pEmailId = sessionStorage.getItem('email');
    if (type == 'recovery') {
      pEmailId = this.paramEmail
    }
    this.manageProfileService.sendMailUpdateNotification(type, pEmailId, this.newEmail, this.person_id).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: response => {
        console.log('API Response:', response); // Debug log

        console.log('email sent successfully');
        console.log('Primary email changed successfully', response);
        this.dialogRef.close({ response: 'success', type: type, newEmail: this.newEmail, });
      },
      error: error => {
        console.error('Error sending email notification:', error);
        this.showFailureToastMsg('Failed to send Email notification for update primary email.');
      }
    });
  }


  migrateOldResendData(): void {
    const oldResendCount = this.localstorage.getItem('resendCount');
    const oldResendBlockTime = this.localstorage.getItem('resendBlockTime');

    if (oldResendCount && !this.localstorage.getItem(this.getResendCountKey())) {
      this.localstorage.setItem(this.getResendCountKey(), oldResendCount);
      this.localstorage.removeItem('resendCount');
    }

    if (oldResendBlockTime && !this.localstorage.getItem(this.getResendBlockTimeKey())) {
      this.localstorage.setItem(this.getResendBlockTimeKey(), oldResendBlockTime);
      this.localstorage.removeItem('resendBlockTime');
    }
  }

  getAllFieldsBlockingStatus(): any {
    const fieldTypes = [
      { type: 'primaryEmail', countKey: 'emailResendCount', blockKey: 'emailResendBlockTime', label: 'Email' },
    ];

    const status: any = {};

    fieldTypes.forEach(field => {
      const count = parseInt(this.localstorage.getItem(field.countKey) || '0', 10);
      const blockTime = this.localstorage.getItem(field.blockKey);
      const lockoutMs = this.otpResendLockoutDuration * 60 * 1000;

      if (blockTime && count >= this.maxResendCount) {
        const blockTimeDate = new Date(blockTime);
        const currentTime = new Date();
        const diff = Math.abs(currentTime.getTime() - blockTimeDate.getTime());

        if (diff < lockoutMs) {
          const remainingMs = (blockTimeDate.getTime() + lockoutMs) - currentTime.getTime();
          const remainingSeconds = Math.ceil(remainingMs / 1000);
          const minutes = Math.floor(remainingSeconds / 60);
          const seconds = remainingSeconds % 60;

          status[field.type] = {
            isBlocked: true,
            attempts: count,
            remainingTime: `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
            remainingSeconds: remainingSeconds,
            label: field.label
          };
        } else {
          status[field.type] = {
            isBlocked: false,
            attempts: 0,
            remainingTime: '00:00',
            remainingSeconds: 0,
            label: field.label
          };
        }
      } else {
        status[field.type] = {
          isBlocked: false,
          attempts: count,
          remainingTime: '00:00',
          remainingSeconds: 0,
          label: field.label
        };
      }
    });

    return status;
  }

  getResendCountKey(): string {
    switch (this.type) {
      case 'primaryEmail': return 'emailResendCount';
    }
  }

  isCurrentFieldBlocked(): boolean {
    const resendCount = parseInt(this.localstorage.getItem(this.getResendCountKey()) || '0', 10);
    const resendBlockTime = this.localstorage.getItem(this.getResendBlockTimeKey());
    const lockoutMs = this.otpResendLockoutDuration * 60 * 1000;

    if (resendBlockTime && resendCount >= this.maxResendCount) {
      const blockTime = new Date(resendBlockTime);
      const currentTime = new Date();
      const diff = Math.abs(currentTime.getTime() - blockTime.getTime());
      return diff < lockoutMs;
    }

    return false;
  }

  getCurrentFieldRemainingTime(): number {
    const resendCount = parseInt(this.localstorage.getItem(this.getResendCountKey()) || '0', 10);
    const resendBlockTime = this.localstorage.getItem(this.getResendBlockTimeKey());
    const lockoutMs = this.otpResendLockoutDuration * 60 * 1000;

    if (resendBlockTime && resendCount >= this.maxResendCount) {
      const blockTime = new Date(resendBlockTime);
      const currentTime = new Date();
      const remainingMs = (blockTime.getTime() + lockoutMs) - currentTime.getTime();
      if (remainingMs > 0) {
        return Math.ceil(remainingMs / 1000);
      }
    }

    return 0;
  }

  getCurrentFieldResendCount(): number {
    return parseInt(this.localstorage.getItem(this.getResendCountKey()) || '0');
  }

  isCurrentFieldMaxResendsReached(): boolean {
    return this.getCurrentFieldResendCount() >= this.maxResendCount;
  }

  getCurrentFieldBlockTimeDisplay(): string {
    const remainingTime = this.getCurrentFieldRemainingTime();
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  getResendBlockTimeKey(): string {
    switch (this.type) {
      case 'primaryEmail': return 'emailResendBlockTime';
    }
  }

  getRecoveryAttemptKey(): string {
    switch (this.type) {
      case 'primaryEmail': return 'emailRecoveryAttempts';
      default: return 'emailRecoveryAttempts';
    }
  }

  getRecoveryAttemptTimeKey(): string {
    switch (this.type) {
      case 'primaryEmail': return 'emailRecoveryAttemptTime';
      default: return 'emailRecoveryAttemptTime';
    }
  }

  logAllFieldsStatus(): void {
    const allStatus = this.getAllFieldsBlockingStatus();
    console.log('=== FIELD BLOCKING STATUS ===');

    Object.keys(allStatus).forEach(fieldType => {
      const status = allStatus[fieldType];
      console.log(`${status.label} (${fieldType}):`);
      console.log(`  - Blocked: ${status.isBlocked}`);
      console.log(`  - Attempts: ${status.attempts}/${this.maxResendCount}`);
      console.log(`  - Remaining Time: ${status.remainingTime}`);
      console.log('---');
    });

    console.log('Current Field:', this.type);
    console.log('Current Field Blocked:', this.isCurrentFieldBlocked());
    console.log('Current Field Remaining Time:', this.getCurrentFieldRemainingTime(), 'seconds');
  }

  get isEmailSendButtonDisabled(): boolean {
    return !this.newEmail ||
      this.invalidEmail ||
      this.emailTooLong ||
      this.isBlocked ||
      this.isCheckingEmail ||
      this.isPrimaryAndRecoverySameEmail ||
      this.emailAlredyExist;
  }


  get isOtpVerifyButtonDisabled(): boolean {
    return (this.otp.join('')).length < 6 ||
      this.timerActive ||
      this.verificationBlockTimeRemaining > 0 ||
      this.isCurrentFieldMaxResendsReached() ||
      this.getCurrentFieldRemainingTime() > 0;
  }

  get isOtpResendButtonDisabled(): boolean {
    return this.timerActive ||
      this.verificationBlockTimeRemaining > 0 ||
      this.isCurrentFieldMaxResendsReached() ||
      this.getCurrentFieldRemainingTime() > 0;
  }

  get invalidEmailFormate(): boolean {

    if (this.newEmail === '' && this.fieldFocus) {
      this.errorMessage = this.errorMessages['M0014']
      return true
    } else if (this.invalidEmail && this.newEmail !== '' && !this.emailTooLong) {
      this.errorMessage = this.errorMessages['M0015']
      return true
    } else if (this.sameEmail && this.type === 'primaryEmail') {
      this.errorMessage = this.errorMessages['M0085']
      return true
    } else if (this.emailTooLong) {
      this.errorMessage = 'Email must be at most 255 characters.'
      return true
    } else if (this.isPrimaryAndRecoverySameEmail) {
      this.errorMessage = this.errorMessages['M0088']
      return true
    }

    return false;

  }


  get showVerificationTimer(): boolean {
    return this.verificationBlockTimeRemaining > 0;
  }

  get showResendTimer(): boolean {
    return this.getCurrentFieldRemainingTime() > 0 && this.verificationBlockTimeRemaining === 0;
  }

  private fieldConfigs = {
    email: {
      allowedKeys: ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'],
      allowNumbers: true,
      allowSpecialChars: ['@', '.', '_', '-', '%'],
      allowLetters: true,
      pasteValidator: /^[a-zA-Z0-9@._%-]*$/,
      inputHandler: (target: HTMLInputElement, value: string) => {
        this.validateEmail(value);
      }
    },
    otp: {
      allowedKeys: ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'],
      allowNumbers: true,
      allowSpecialChars: [],
      allowLetters: false,
      pasteValidator: /^\d*$/,
      inputHandler: (target: HTMLInputElement, value: string, index?: number) => {
        if (index !== undefined) {
          this.onOtpChange(index, { target } as any);
        }
      }
    }
  };

  onOtpBlur(): void {
    this.fieldFocus = false;
    this.otpTouched = true;
    if (this.otp.join('').length === 0) {
      this.showOtpError = true;
      this.errorMessage = this.errorMessages['M0045'];
      this.cdr.detectChanges();
    } else {
      this.showOtpError = false;
      this.errorMessage = '';
      this.cdr.detectChanges();
    }
  }


  setShortToastTimer() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
    this.toastTimer = setTimeout(() => {
      this.showToast = false;
    }, 4000);

  }

  showFailureToastMsg(msg: string) {
    this.toastTitle = '';
    // this.toastMessageText = msg;
    this.alertService.error(msg, true);
    // this.toastType = 'error';
    // this.showToast = true;
    // this.setShortToastTimer();
    window.scrollTo(0, 0);
  }

  showSuccessToastMsg(msg: string) {
    this.toastTitle = '';
    // this.toastMessageText = msg;
    this.alertService.success(msg, true);
    // this.toastType = 'success';
    // this.showToast = true;
    // this.setShortToastTimer();
    window.scrollTo(0, 0);
  }

  private loadOtpValidationRules() {
    this.commonService.loadOtpValidationRules(this.manageProfileService, this.destroy$)
      .then(rules => {
        this.maxAttempts = rules.maxAttempts;
        this.maxResendCount = rules.maxResendCount;
        this.otpLockoutDuration = rules.otpLockoutDuration;
        this.otpResendCooldown = rules.otpResendCooldown;
        this.resendTimer = rules.resendTimer || rules.otpResendCooldown;
        this.otpResendLockoutDuration = rules.otpResendLockoutDuration;
      })
      .catch(error => {
        console.error('Error loading OTP validation rules:', error);
      });
  }

  private notifyPrimaryEmailUpdate(): void {
    const userId = this.localstorage.getItem('id');
    const payload = {
      priority: "High",
      message: "Your primary email address has been updated successfully.",
      actionurl: "/pages/manage-profile",
      userid: userId,
      customformid: 1,
      isnew: true,
      isactive: true
    };
    
    this.fingerprintService.FingerPrintPortalnotifiction(payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (!res.data.success) {
            console.error('Error while sending email update notification');
          }
        },
        error: err => {
          console.error('Error sending email update notification:', err);
        }
      });
  }
  ngOnDestroy(): void {
    this.showSecond = false;
    this.clearTimer();
    this.clearResendBlockTimer();
    this.newEmail = '';
    this.destroy$.next();
    this.destroy$.complete()
  }

}
